import { getSubscriptionProduct } from '../../data/serviceCatalogue';

/**
 * Membership page copy — the owner's copy pass of 2026-09-15. What's included
 * is now written here rather than read from the service catalogue: the
 * catalogue still carries stale enrolment lines (a £395 "Plus" membership) and
 * the FAQ brief says it must not be used as a copy source. Prices stay hidden
 * until the owner decides otherwise (2026-09-11: no prices).
 *
 * Public prose rules: closed em dashes, no Oxford comma.
 */

export const MEMBERSHIP_META = {
  title: 'Melio membership · a practice in your corner, all year',
  description:
    'A named care team, a baseline assessment of your health and history, quarterly clinician-reviewed plans and a continuous record read by people who know you.',
} as const;

export const MEMBERSHIP_INTRO = {
  statement:
    'Members keep a clinical practice in their corner all year: a named care team, a baseline assessment of your health and history, quarterly clinician-guided reports and a continuous record that is actually read by people who know you.',
} as const;

export const SHOW_PRICES = false;

/**
 * What's included, in the owner's order. The first line was highlighted in
 * the 2026-09-15 notes without a replacement; kept verbatim pending a decision.
 */
export const MEMBERSHIP_INCLUDED: string[] = [
  'Living prevention dashboard with due-next guidance',
  'Quarterly clinician-reviewed plan refreshes',
  'Structured follow-up, reminders and open-loop tracking',
  'Secure record for uploads, results and family context',
  'Care navigation between consultations',
];

/** Lines that are billing terms, never benefits. Guarded by the content test. */
export const BILLING_TERMS = /billed|commitment|add-ons/i;

export function membershipIncludes(): string[] {
  return MEMBERSHIP_INCLUDED;
}

export function membershipPriceLine(): string | null {
  if (!SHOW_PRICES) return null;
  const product = getSubscriptionProduct();
  if (!product) return null;
  return `£${product.priceGbp} ${product.priceNote ?? ''}`.trim();
}

export const MEMBERSHIP_SECTIONS = {
  included: { numeral: 'I', title: "What's included" },
  how: { numeral: 'II', title: 'How it works' },
  who: { numeral: 'III', title: "Who it's for" },
} as const;

export const WHO_ITS_FOR: string[] = [
  'People who want one place and one team to hold their health: the results, the history, the specialists, the plan.',
  'People who would rather anticipate than react and who want the follow-through done for them rather than handed back as a list.',
];
